module.exports = __webpack_public_path__ + "assets/orange-sm-logo-69db53.svg";